// src/components/Navbar.jsx
import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { FiShoppingCart } from "react-icons/fi";
import logo from "../assets/images/PriniCrackers.jpg";
import "../styles/Navbar.css";
import { useCart } from "../context/CartContext";

const NavBarData = {
  links: [
    { name: "Home", to: "/", end: true },
    { name: "About Us", to: "/about-us" },
    { name: "Products", to: "/products" },
    { name: "Offers", to: "/offers" },
    { name: "Safety Tips", to: "/safety-tips" },
    { name: "Contact", to: "/contact" },
  ],
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef(null);
  const { cartItems } = useCart();

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const totalItems = cartItems.reduce((acc, item) => acc + item.quantity, 0);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && navRef.current && !navRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <nav className="nav-wrapper" ref={navRef}>
      <div className="nav-brand">
        <NavLink to="/" className="nav-logo" onClick={closeMenu}>
          <img src={logo} alt="Prini Crackers Logo" className="nav-logo-img" />
        </NavLink>

        {/* Mobile Cart & Hamburger */}
        <div className="nav-actions">
          <NavLink
            to="/cart"
            className={({ isActive }) =>
              `mobile-cart-icon ${isActive ? "active" : ""}`
            }
            onClick={closeMenu}
            aria-label={`Cart with ${totalItems} item${totalItems !== 1 ? "s" : ""}`}
          >
            <FiShoppingCart size={22} />
            {totalItems > 0 && <span className="cart-count">{totalItems}</span>}
          </NavLink>

          <button
            className="hamburger"
            onClick={toggleMenu}
            aria-label="Toggle menu"
            aria-expanded={isOpen}
          >
            <span className={`bar ${isOpen ? "open" : ""}`} />
            <span className={`bar ${isOpen ? "open" : ""}`} />
            <span className={`bar ${isOpen ? "open" : ""}`} />
          </button>
        </div>
      </div>

      <ul className={`nav-links ${isOpen ? "show" : ""}`}>
        {NavBarData.links.map(({ name, to, end }, idx) => (
          <li key={idx}>
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              {name}
            </NavLink>
          </li>
        ))}

        {/* Desktop Cart */}
        <li className="desktop-cart-link">
          <NavLink
            to="/cart"
            className={({ isActive }) => (isActive ? "active cart-link" : "cart-link")}
            onClick={closeMenu}
            aria-label={`Cart with ${totalItems} item${totalItems !== 1 ? "s" : ""}`}
          >
            <FiShoppingCart size={20} />
            {totalItems > 0 && <span className="cart-count">{totalItems}</span>}
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
